import { alpha, Box, useTheme } from "@mui/material";
import type { FC, ReactNode } from "react";

type Props = {
	children: ReactNode;
};

export const StickyCtaBar: FC<Props> = ({ children }) => {
	const { palette, spacingTokens, bottomSpacing } = useTheme();
	const pageBg = palette.surface.muted;

	return (
		<Box
			mt="auto"
			px={spacingTokens.lg}
			pt={spacingTokens.xxl}
			pb={bottomSpacing.stickyCta}
			position="sticky"
			bottom={0}
			zIndex={1}
			sx={{
				background: `linear-gradient(to top, ${pageBg} 0%, ${pageBg} 60%, ${alpha(pageBg, 0)} 100%)`,
			}}
		>
			{children}
		</Box>
	);
};
